import OperatorApplicationMessageOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageOpenApiModel;
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;

export default function createMockMessage(client: OperatorApplicationClientOpenApiModel): OperatorApplicationMessageOpenApiModel {
    let time = (new Date()).getTime();
    return {
        id: time,
        isMentioned: false,
        isCrossOperatorsChat: client.type.isCrossOperatorsChat,
        isCrossOperatorsConversationChat: client.type.isCrossOperatorsConversationChat,
        username: client.username,
        text: "",
        operatorLogin: null,
        isDelayed: false,
        statusId: null,
        content: {
            text: ""
        },
        tags: [],
        dialogId: null,
        dialog: null,
        displayNotification: false,
        temporaryId: null,
        isEditable: false,
        dateTime: time,
        error: null,
        isRemovable: false,
        isSendByClient: false,
        recipients: [],
        contacts: [],
        hasSeparateStatus: false,
        messageType: null,
        isRealOperator: true,
        operatorsStatus: [],
        isRemoved: false,
        isPinned: false,
        isPinable: false,
        senderInfo: {},
        isSystemChat: false,
        isAnswerable: false,
        isReactionAvailable: false,
        isDictationUsed: false,
        isSentBySuggest: false,
        suggestedAnswers: []
    };
}